import React, { useState, useEffect } from 'react';
import appGoogleTracking from '../../modules/googletracking';

/*
    Google tagging plan added on links using : appGoogleTracking.processEventCTA
*/

const Header = () => {
    const [isLogoVisible, setIsLogoVisible] = useState(false);

    useEffect(() => {

        window.addEventListener('scroll', handleScroll);


        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const handleScroll = () => {

        const scrollPosition = window.scrollY || document.documentElement.scrollTop;
        if (scrollPosition < 167) setIsLogoVisible(false);
        else setIsLogoVisible(true);

    };
    const [value, setValue] = useState('');

    const handleChange = (event) => {
        setValue(event.target.value);
    }
    return (
        <header>
            {/* /////mobile/////// */}
            <nav className="js-header header__container">
                <div className="header__head">
                    <img className="header__pull js-pull-animate" src="resources/images/icons/Pull_Out_Shape.svg" alt="print" />
                    <div className="js-hamburger header__menu" id="hamburger-m"><span className="menu-line"></span><span className="menu-line"></span> <span className="menu-line"></span><span className="menu-line"></span></div>
                    <div className="header__logo">
                        <a
                            href="https://www.milka.at/"
                            target="_blank"
                            rel="noopener noreferrer"
                            data-event="go_to_Milka"
                            data-category="Header"
                            data-action="Go to Page"
                            data-label="MILKA_ALLPAGE_NAVBAR"
                            onClick={appGoogleTracking.processEventCTA}
                        >
                            <span className="icon-milka-logo"></span>
                        </a>
                    </div>
                </div>
                <div className="header__content js-ham-content">
                    <div className="header__head">
                        <div className="js-ham-close"><span className="icon-home"></span></div>
                    </div>
                    <div className="header__navigations">
                        <ul>
                            <li>
                                <a
                                    className="header__navigation js-event-cta"
                                    data-event="header_menu"
                                    data-category="Header"
                                    data-action="Select Menu"
                                    data-label="PRODUKTE"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://milka.at/alle-produkte/"
                                    onClick={appGoogleTracking.processEventCTA}>Produkte</a>
                            </li>
                            <li>
                                <a
                                    className="header__navigation js-event-cta"
                                    data-event="header_menu"
                                    data-category="Header"
                                    data-action="Select Menu"
                                    data-label="NEUES"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://milka.at/nachhaltigkeit/"
                                    onClick={appGoogleTracking.processEventCTA}>Nachhaltigkeit</a>
                            </li>
                            <li>
                                <a
                                    className="header__navigation js-event-cta"
                                    data-event="header_menu"
                                    data-category="Header"
                                    data-action="Select Menu"
                                    data-label="KARRIERE"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://milka.at/ueber-milka/"
                                    onClick={appGoogleTracking.processEventCTA}>Über Milka</a>
                            </li>
                            <li>
                                <a
                                    className="header__navigation js-event-cta"
                                    data-event="header_menu"
                                    data-category="Header"
                                    data-action="Select Menu"
                                    data-label="UBER MILKA"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href="https://milka.at/neues/"
                                    onClick={appGoogleTracking.processEventCTA}>Neues</a>
                            </li>
                        </ul>
                        <div className="header__end"></div>
                    </div>
                </div>
            </nav>

            {/* /////WEB/////// */}
            <nav className="js-header header-md__container">
                <div className={`header-md__logo`}>
                    <a className="nav__item js-event-cta" data-event="go_to_milka" data-category="Header" data-action="Go to Page" data-label="MILKA_ALLPAGE_NAVBAR" onClick={appGoogleTracking.processEventCTA} href="https://www.milka.at/" target="_blank" rel="noopener noreferrer"><span className="icon-milka-logo"></span></a>
                </div>
                <div className="js-header-md-hamburger header-md__menu">
                    <div className="header__btn" id="hamburger"><span className="menu-line"></span><span className="menu-line"></span><span className="menu-line"></span><span className="menu-line"></span></div>
                </div>
                <div className="js-header-md-content header-md__content">
                    <ul className="header-md__navigations">
                        <li>
                            <a
                                className="header-md__navigation js-event-cta"
                                data-event="header_menu"
                                data-category="Header"
                                data-action="Select Menu"
                                data-label="PRODUKTE"
                                href="https://milka.at/alle-produkte/"
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={appGoogleTracking.processEventCTA}>Produkte</a>
                        </li>
                        <li>
                            <a
                                className="header-md__navigation js-event-cta"
                                data-event="header_menu"
                                data-category="Header"
                                data-action="Select Menu"
                                data-label="NEUES"
                                href="https://milka.at/nachhaltigkeit/"
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={appGoogleTracking.processEventCTA}>Nachhaltigkeit</a>
                        </li>
                        <li>
                            <a
                                className="header-md__navigation js-event-cta"
                                data-event="header_menu"
                                data-category="Header"
                                data-action="Select Menu"
                                data-label="KARRIERE"
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://milka.at/ueber-milka/"
                                onClick={appGoogleTracking.processEventCTA}>Über Milka</a>
                        </li>
                        <li>
                            <a
                                className="header-md__navigation js-event-cta"
                                data-event="header_menu"
                                data-category="Header"
                                data-action="Select Menu"
                                data-label="UBER MILKA"
                                href="https://milka.at/neues/"
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={appGoogleTracking.processEventCTA}>Neues
                            </a>
                        </li>
                    </ul>
                </div>
            </nav>
        </header>
    );
}

export default Header;